import React, {Component} from "react";
import "./index.scss";
import {SuccessIcon,} from "components/Icon";
import Modal from "components/Modal";
import ScheduleCallModal from "components/contact/ScheduleCallModal";

interface BookingEnquirySuccessModalProps {
  open: boolean;
  onClosing?: ()=>void;
}

interface BookingEnquirySuccessModalState {
  contactOpen: boolean;
}

export default class BookingEnquirySuccessModal extends Component<BookingEnquirySuccessModalProps, BookingEnquirySuccessModalState> {
  state: BookingEnquirySuccessModalState = {
    contactOpen: false
  };

  onSuccessModalClosing = () => {
    if(this.props.onClosing) {
      this.props.onClosing();
    }
  };

  onContactClick = () => {
    this.setState({ contactOpen: true });
  };

  onContactModalClosing = () => {
    if(this.props.onClosing) {
      this.props.onClosing();
    }
  };

  renderContactModal() {
    return (
      <ScheduleCallModal
        open={this.props.open && this.state.contactOpen}
        onClosing={this.onContactModalClosing}
      />
    );
  }

  renderSuccessModal() {
    return (
      <Modal
        open={this.props.open && !this.state.contactOpen}
        onClosing={this.onSuccessModalClosing}
        className="booking-enquiry-success"
      >
        <p className="message">
          <SuccessIcon /> Thank you for your interest. A member of our team will
          be in touch soon.
        </p>
        <p className="contact">
          Or schedule a meeting{" "}
          <button onClick={this.onContactClick}>now</button>.
        </p>
      </Modal>
    );
  }

  render() {
    return <>
      {this.renderSuccessModal()}
      {this.renderContactModal()}
    </>;
  }
}
